import React, { useEffect, useRef } from 'react';
import { Typography, Box } from '@mui/material';

export default function Stopwatch({ isRunning, elapsedSeconds = 0, onTick }) {
  const intervalRef = useRef(null);
  const currentSeconds = useRef(elapsedSeconds);

  useEffect(() => {
    currentSeconds.current = elapsedSeconds;
  }, [elapsedSeconds]);

  useEffect(() => {
    if (isRunning) {
      intervalRef.current = setInterval(() => {
        currentSeconds.current += 1;
        onTick(currentSeconds.current);
      }, 1000);
    } else {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [isRunning, onTick]);

  const formatTime = (totalSeconds) => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return `${hours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  };

  return (
    <Box 
      data-testid="stopwatch"
      role="timer"
      aria-label={`Meeting timer: ${formatTime(elapsedSeconds)}, ${isRunning ? 'running' : 'stopped'}`}
      sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        p: 2 
      }}
    >
      <Typography
        variant="h2"
        aria-live="polite"
        aria-atomic="true"
        sx={{
          fontFamily: 'monospace',
          fontWeight: 'bold',
          color: isRunning ? 'success.main' : 'text.primary',
          letterSpacing: 2,
        }}
      >
        {formatTime(elapsedSeconds)}
      </Typography>
    </Box>
  );
}